import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Scale } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { getStoredReferrerId, clearStoredReferrerId } from "../components/ReferralTracker";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const referrerId = getStoredReferrerId();
        const payload = { session_id: sessionId };
        if (referrerId) payload.referrer_id = referrerId;
        const res = await api.post("/auth/session", payload);
        if (referrerId) clearStoredReferrerId();
        setUser(res.data.user);
        // Preserve original path/search if user was redirected from a deep link
        const target = window.location.pathname + window.location.search;
        const finalTarget = target && target !== "/" ? target : "/sos";
        navigate(finalTarget, { replace: true, state: { user: res.data.user } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <Scale className="h-10 w-10 text-slate-900 animate-pulse" />
        <p className="text-sm text-slate-500 tracking-[0.3em] uppercase">Authentification</p>
      </div>
    </div>
  );
}
